/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolHubIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-hub"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6 23.38Q6 23.38 5.3 23.38Q4.6 23.38 3.61 22.39Q2.63 21.4 2.63 20Q2.63 18.6 3.61 17.61Q4.6 16.63 6 16.63Q6.3 16.63 6.56 16.68Q6.83 16.73 7.1 16.82L8.3 15.35Q7.72 14.63 7.51 13.84Q7.3 13.05 7.33 12.13L5.67 11.57Q5.2 12.18 4.5 12.53Q3.8 12.88 3 12.88Q1.6 12.88 0.61 11.89Q-0.38 10.9 -0.38 9.5Q-0.38 8.1 0.61 7.11Q1.6 6.13 3 6.13Q4.38 6.13 5.36 7.09Q6.35 8.05 6.38 9.43Q6.38 9.43 6.38 9.43Q6.38 9.43 6.38 9.43L8.05 10.03Q8.53 9.28 9.25 8.74Q9.97 8.2 10.88 7.95L10.88 6.17Q9.9 5.83 9.26 4.97Q8.63 4.13 8.63 3Q8.63 1.6 9.61 0.61Q10.6 -0.38 12 -0.38Q13.4 -0.38 14.39 0.61Q15.38 1.6 15.38 3Q15.38 4.13 14.74 4.97Q14.1 5.83 13.13 6.17L13.13 7.95Q14.05 8.2 14.76 8.71Q15.47 9.22 15.95 10.03L17.63 9.43Q17.63 9.4 17.63 9.41Q17.63 9.43 17.63 9.43Q17.68 8.05 18.65 7.09Q19.63 6.13 21 6.13Q22.4 6.13 23.39 7.11Q24.38 8.1 24.38 9.5Q24.38 10.9 23.39 11.89Q22.4 12.88 21 12.88Q20.2 12.88 19.5 12.53Q18.8 12.18 18.32 11.57L16.65 12.13Q16.68 13.05 16.48 13.84Q16.27 14.63 15.7 15.35L16.9 16.8Q17.18 16.7 17.44 16.66Q17.7 16.63 18 16.63Q19.4 16.63 20.39 17.61Q21.38 18.6 21.38 20Q21.38 21.4 20.39 22.39Q19.4 23.38 18 23.38Q16.6 23.38 15.61 22.39Q14.63 21.4 14.63 20Q14.63 19.5 14.75 19.06Q14.88 18.63 15.13 18.23L13.97 16.75Q13.05 17.18 12 17.18Q10.95 17.18 10.03 16.75L8.88 18.23Q9.13 18.63 9.25 19.06Q9.38 19.5 9.38 20Q9.38 21.4 8.39 22.39Q7.4 23.38 6 23.38Z" fill={color} />
    </svg>
  );
}
